import { MPGModel } from '@app/models/MPGModel';
import { MPGRepository } from '@app/repositories/MPGRepository';
import { ServiceBase } from '@app/services/ServiceBase';

export class MPGService extends ServiceBase<MPGModel, MPGRepository<MPGModel>> {
    public constructor() {
        super(new MPGRepository());
    }
}
